import o from "./index648.js";
import { withInstall as t } from "./index604.js";
const a = t(o);
export {
  a as ElIcon,
  a as default
};
